import { Checkbox, FormControlLabel, Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { LastStepVM, SectionVM } from 'civil-status/view-models/step-form';
import { KeySections } from 'civil-status/constants/keys-subjects-section';
import { dataMaintenanceSection } from 'civil-status/constants/data-maintenance-section';
import { initialValuesSections } from 'civil-status/constants/initial-values-step';

interface ReceivedByPostProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
  controllIsReceivedByPost: (isReceivedByPost?: boolean) => void;
  formContext: FormikProps<LastStepVM>;
  keySection: string;
}

const ReceivedByPostComponent = ({
  disabled = false,
  values,
  formContext,
  keySection,
}: ReceivedByPostProps): React.ReactElement => {
  const onChange = useEventCallback(() => {
    formContext.setValues({
      ...(formContext.values || {}),
      [keySection]: {
        ...(formContext.values[keySection] || {}),
        isReceivedByPost: !values?.isReceivedByPost,
      } as SectionVM,
      [KeySections.keyDatiEventoCittadinanza]: {
        ...initialValuesSections,
        ...dataMaintenanceSection(formContext.values[KeySections.keyDatiEventoCittadinanza]),
        isRequiredFromOtherAccordion: !values?.isReceivedByPost,
      },
      [KeySections.keyDatiTrascrizioneCittadinanza]: {
        ...initialValuesSections,
        ...dataMaintenanceSection(formContext.values[KeySections.keyDatiTrascrizioneCittadinanza]),
        isRequiredFromOtherAccordion: values?.isReceivedByPost,
      },
    });
  });

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="isReceivedByPost"
              checked={values?.isReceivedByPost || false}
              onChange={onChange}
              inputProps={{ 'aria-label': 'Ricevuta per posta' }}
              disabled={disabled}
            />
          }
          label="Ricevuta per posta"
        />
      </Grid>
    </Grid>
  );
};

ReceivedByPostComponent.displayName = 'Received By Post component';

const ReceivedByPost = memo(ReceivedByPostComponent);

export default ReceivedByPost;
